import {
  OperationVariables,
  DocumentNode,
  useMutation as apolloUseMutation,
} from '@apollo/client';

import { Mutation } from '@/apollo/__generated__/graphql';
import { MutationTuple, MutationHookOptions } from '@/types';

/**
 * @deprecated
 * Use the useMutation directly from apollo client
 * @param mutation
 * @param options
 * @returns
 */
const useMutation = <T extends OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<T>,
): MutationTuple<T> => apolloUseMutation<Mutation, T>(mutation, options);

export default useMutation;
